import workspaceQuery from 'graphql/queries/sales/DeliveryRouteWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/sales/DeliveryRouteListQuery.graphql';
import instanceQuery from 'graphql/queries/sales/DeliveryRouteQuery.graphql';
import defaultQuery from 'graphql/queries/sales/DeliveryRouteDefault.graphql';
import mutationQuery from 'graphql/mutations/sales/DeliveryRouteMutation.graphql';
import fragment from 'graphql/fragments/sales/DeliveryRouteFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const DeliveryRoute: EntityType = {
  type: 'DeliveryRoute',
  title: 'Delivery Routes',
  formTitle: 'Delivery Route',
  formUrl: '/Sales/DeliveryRoute/Details/',
  workspaceUrl: '/Sales/DeliveryRoute/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SALES_DELIVERY_ROUTE',
};

export default DeliveryRoute;
